import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=1080cdba&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=ts"
export * from "./Notice.vue?vue&type=script&lang=ts"
import style0 from "./Notice.vue?vue&type=style&index=0&id=1080cdba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1080cdba",
  null
  
)

export default component.exports